import { Input as InputAntd } from 'antd';

import FormField from '../Field';

const Input = FormField<string>(InputAntd);

export default Input;
